import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericApiResponse } from '../../core/models/api-response.model';

export interface UserProfileVo {
    firstName: string;
    lastName: string;
    mobileNumber: string;
    emailAddress: string;
    alternateMobileNumber: string;
}

export interface ChangePasswordVo {
    currentPassword: string;
	newPassword: string;
	instance: string;
}

@Injectable({
    providedIn: 'root'
})
export class UserProfileService {
    
    constructor(private http: HttpClient) { }

    // GET request
    getUserInfo(): Observable<UserProfileVo> {
        return this.http.get<UserProfileVo>('/user-profile/v1');
    }

    updateUserProfile(body: UserProfileVo): Observable<UserProfileVo> {
        return this.http.post<UserProfileVo>('/user-profile/v1', body);
    }

    deactivateAccount(): Observable<GenericApiResponse> {
        return this.http.post<GenericApiResponse>('/user-profile/v1/deactivate-account', {});
    }

    changeUserPassword(body: ChangePasswordVo): Observable<GenericApiResponse> {
        return this.http.post<GenericApiResponse>('/user-profile/v1/change-password', body);
    }

    changeUserPasswordFromPublic(body: ChangePasswordVo): Observable<GenericApiResponse> {
        return this.http.post<GenericApiResponse>('/user-profile/v1/public/change-password', body);
    }
}